import {
  Button,
  ButtonGroup,
  Col,
  Form,
  Row,
} from "react-bootstrap";
import {
  useAddContactMutation,
  useGetAllSongContactsQuery,
  useUpdateContactMutation,
} from "../../slices/songsApiSlice";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const Contacts = () => {
  const [selectedContact, setSelectedContact] = useState(null);
  const [isFormDirty, setIsFormDirty] = useState(false);

  const [formData, setFormData] = useState({
    id: null,
    firstName: "",
    surname: "",
    whatsApp: "",
    sms: "",
    email: "",
  });

  const {
    data: songContacts,
    error: songContactsError,
    isLoading: songContactsLoading,
  } = useGetAllSongContactsQuery();

  const [addContact] = useAddContactMutation();
  const [updateContact] = useUpdateContactMutation();

  useEffect(() => {
    if (songContacts) {
      if (selectedContact === null) {
        setSelectedContact(songContacts[0]._id);
      } else {
        const selectedContactData = songContacts.find(
          (contact) => contact._id === selectedContact
        );
        if (selectedContactData) {
          setFormData({
            id: selectedContact,
            firstName: selectedContactData.firstName,
            surname: selectedContactData.surname,
            whatsApp: selectedContactData.whatsApp,
            sms: selectedContactData.sms,
            email: selectedContactData.email,
          });
        }
      }
    }
  }, [selectedContact, songContacts]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.firstName || !formData.surname) {
      toast.error("All fields are required. Document not saved.", {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    if (formData.id !== null) {
      await updateContact(formData);
    } else {
      const newContact = await addContact(formData);
      setSelectedContact(newContact.data._id);
    }
    setIsFormDirty(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    setIsFormDirty(true);
  };

  const handleAddContact = () => {
    setFormData({
      id: null,
      firstName: "",
      surname: "",
      whatsApp: "",
      sms: "",
      email: "",
    });
    setIsFormDirty(true);
  };

  return (
    <>
      <Row className="mt-4">
        <Col
          xs="3"
          style={{ height: "1000px", overflowY: "scroll" }}
          className="p-2 border border-1"
        >
          {songContactsError ? (
            <div>Error loading Contacts</div>
          ) : songContactsLoading ? (
            <div>Loading Contacts...</div>
          ) : (
            <ButtonGroup
              vertical
              size="sm"
              className="col-12"
            >
              {songContacts &&
                songContacts.map((contact) => (
                  <Button
                    key={contact._id}
                    variant={
                      selectedContact === contact._id ? "primary" : "light"
                    }
                    onClick={() => {
                      setSelectedContact(contact._id);
                      setIsFormDirty(false);
                    }}
                    // onClick={() => handleButtonClick(ident._id)}
                  >
                    <div className="text-capitalize text-start">
                      {contact.firstName} {contact.surname}
                    </div>
                  </Button>
                ))}
            </ButtonGroup>
          )}
        </Col>
        <Col className="p-2 border border-1 border-start-0">
          <Row>
            <Col>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col>
                    <Row className="h4 border-bottom pb-3 ">
                      <Col className="text-center">
                        {selectedContact !== null
                          ? "Update Contact"
                          : "Add Contact"}
                      </Col>
                    </Row>
                    <Row
                      key={"firstName"}
                      className="justify-content-center"
                    >
                      <Col
                        sm={2}
                        className="text-end mt-2 "
                      >
                        First Name
                      </Col>
                      <Col>
                        <Form.Group
                          controlId={formData.firstName}
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            name="firstName"
                            placeholder={`Enter First Name`}
                            value={formData.firstName}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row
                      key={"surname"}
                      className="justify-content-center"
                    >
                      <Col
                        sm={2}
                        className="text-end mt-2 "
                      >
                        Last Name
                      </Col>
                      <Col>
                        <Form.Group
                          controlId={formData.surname}
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            name="surname"
                            placeholder={`Enter Last Name`}
                            value={formData.surname}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row
                      key={"whatsApp"}
                      className="justify-content-center"
                    >
                      <Col
                        sm={2}
                        className="text-end mt-2 "
                      >
                        WhatsApp
                      </Col>
                      <Col>
                        <Form.Group
                          controlId={formData.whatsApp}
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            name="whatsApp"
                            placeholder={`Enter WhatsApp Number`}
                            value={formData.whatsApp}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row
                      key={"sms"}
                      className="justify-content-center"
                    >
                      <Col
                        sm={2}
                        className="text-end mt-2 "
                      >
                        SMS
                      </Col>
                      <Col>
                        <Form.Group
                          controlId={formData.sms}
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            name="sms"
                            placeholder={`Enter SMS Number`}
                            value={formData.sms}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row
                      key={"email"}
                      className="justify-content-center"
                    >
                      <Col
                        sm={2}
                        className="text-end mt-2 "
                      >
                        Email Address
                      </Col>
                      <Col>
                        <Form.Group
                          controlId={formData.email}
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            name="email"
                            placeholder={`Enter Email Address`}
                            value={formData.email}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-3 ">
                  <Col className="text-end mt-3 ">
                    <Button
                      variant="success"
                      className="ms-3 me-5 "
                      onClick={handleAddContact}
                      disabled={isFormDirty}
                    >
                      Add New
                    </Button>
                    <Button
                      variant="danger"
                      type="submit"
                      className="ms-3 me-5"
                      disabled={!isFormDirty}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default Contacts;
